import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import { CreateAchievement } from "../services/AchieService";

const CreateAchie = () => {
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [selectedType, setSelectedType] = useState("rank_random_10_days");
  const [points, setPoints] = useState(1);
  const [dateAchieved, setDateAchieved] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const typeAchies = [
    { label: "rank_random_10_days", value: "Giải 10 ngày" },
    { label: "rank_random_10_days_voucher", value: "Giải 10 ngày voucher" },
    { label: "rank_random_20_days", value: "Giải 20 ngày" },
    { label: "rank_random_20_days_voucher", value: "Giải 20 ngày voucher" },
    { label: "rank_random_30_days", value: "Giải 30 ngày" },
    { label: "rank_random_30_days_voucher", value: "Giải 30 ngày voucher" },
  ];

  const handleCreateAchie = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await CreateAchievement(userId, name, selectedType, points, dateAchieved);
      if (response.status_code === 200) {
        dispatch(setSuccessMessage("Tạo giải thưởng thành công!"));
        // Reset form
        setUserId("");
        setName("");
        setSelectedType("rank_random_10_days");
        setPoints(1);
        setDateAchieved(new Date().toISOString().split("T")[0]);
      } else {
        dispatch(setErrorMessage(response.message || "Có lỗi xảy ra"));
      }
    } catch (error) {
      dispatch(setErrorMessage("Có lỗi xảy ra khi tạo giải thưởng"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
      <div className="w-full max-w-2xl">
        <h1 className="text-3xl font-bold text-center text-gray-800 dark:text-white mb-8">
          Tạo Giải Thưởng Mới
        </h1>

        <form
          onSubmit={handleCreateAchie}
          className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6"
        >
          <div className="space-y-6">
            {/* Thông tin giải thưởng */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300 border-b pb-2">
                Thông tin giải thưởng
              </h2>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  User ID
                </label>
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Nhập User ID"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Tên giải thưởng
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Nhập tên giải thưởng"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Loại giải thưởng
                </label>
                <select
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {typeAchies.map((type) => (
                    <option key={type.label} value={type.label}>
                      {type.value}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Số điểm
                </label>
                <input
                  type="number"
                  min={1}
                  value={points}
                  onChange={(e) => setPoints(Number(e.target.value))}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Nhập số điểm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Ngày đạt giải
                </label>
                <input
                  type="date"
                  value={dateAchieved}
                  onChange={(e) => setDateAchieved(e.target.value)}
                  required
                  className="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-colors"
            >
              Hủy
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? "Đang tạo..." : "Tạo giải thưởng"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAchie;